module.exports = __webpack_public_path__ + "static/media/lockin.ed4e9b27.png";